import { render, staticRenderFns } from "./EmAclRoleEdit.vue?vue&type=template&id=44c020b2&"
import script from "./EmAclRoleEdit.vue?vue&type=script&lang=js&"
export * from "./EmAclRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports